import { render, staticRenderFns } from "./myExercise.vue?vue&type=template&id=5c2591e2&scoped=true"
import script from "./myExercise.vue?vue&type=script&lang=js"
export * from "./myExercise.vue?vue&type=script&lang=js"
import style0 from "./myExercise.vue?vue&type=style&index=0&id=5c2591e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2591e2",
  null
  
)

export default component.exports